import React from 'react'
import PropTypes from 'prop-types'
import nofollow from '../../../utils/helpers/nofollow'

import { CTAButton, WrapperLink } from './styled'

const Button = ({
  children,
  kind = 'primary',
  size,
  destination,
  forceFullWidth,
  target,
  alignment,
}) => {
  return (
    <WrapperLink
      href={destination}
      target={target || '_self'}
      alignment={alignment}
      rel={nofollow(target)}
    >
      <CTAButton kind={kind} size={size} forceFullWidth={forceFullWidth}>
        {children}
      </CTAButton>
    </WrapperLink>
  )
}

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  kind: PropTypes.oneOf([
    'ghost',
    'secondary',
    'primary',
    'text',
    'green',
    'red',
  ]),
  size: PropTypes.oneOf(['base', 'large']),
  destination: PropTypes.string,
  forceFullWidth: PropTypes.bool,
  target: PropTypes.string,
  alignment: PropTypes.string,
}

export default Button



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/atoms/Button/Button.js